export default __webpack_public_path__ + "static/iPhone11ProMax-8341cd128f557323a1840c780c800b56.png";